"use client";

import { motion } from "framer-motion";
import Image from "next/image";
import Link from "next/link";

interface Lab {
  url: string;
  ogImage: string;
  title: string;
  description: string;
}

interface LabCardsProps {
  labs: Lab[];
}

export default function LabCards({ labs }: LabCardsProps) {
  return (
    <div className="grid md:grid-cols-3 gap-6">
      {labs.map((lab, index) => (
        <motion.div
          key={index}
          className="group relative rounded-2xl overflow-hidden bg-white/5 backdrop-blur-sm border border-border-light dark:border-border-dark"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.2 }}
        >
          <Link href={lab.url} className="block">
            <div className="aspect-video relative">
              <Image
                src={lab.ogImage}
                alt={lab.title}
                fill
                className="object-cover transition-transform group-hover:scale-105"
              />
            </div>
            <div className="p-6">
              <h4 className="text-lg font-medium mb-2">{lab.title}</h4>
              <p className="text-gray-600 dark:text-gray-300">
                {lab.description}
              </p>
            </div>
          </Link>
        </motion.div>
      ))}
    </div>
  );
}
